module.exports = require("vfile");


//////////////////
// WEBPACK FOOTER
// external "vfile"
// module id = 46
// module chunks = 0 1 2 3 4 5 6 7 10 11